import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import Modal from 'LuxKit/Modal/Modal'
import BedbankCancellationPolicy from 'components/OfferPage/Bedbank/BedbankCancellationPolicy'
import ModalContext from 'contexts/ModalContext'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import useBedbankOfferSearchPricing from 'hooks/useBedbankOfferSearchPricing'
import { EmptyObject } from 'lib/object/objectUtils'
import { getHotelOfferUrl } from 'lib/offer/offerPageURL'
import { buildBedbankCancellationPolicy } from 'lib/search/hotels'
import React, { useCallback, useContext, useMemo } from 'react'
import ExperimentalSearchTileFeaturesList from '../shared/ExperimentalSearchTileFeaturesList'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
}

function ExperimentalBedbankLTSSearchTileFeatures({ offer, filters = EmptyObject }: Props) {
  const { shownRate } = useBedbankOfferSearchPricing(offer, filters)
  const offerMetaData = useOfferMetaData(offer.id, filters)
  const cancellationPolicy = useMemo(() => {
    return buildBedbankCancellationPolicy(
      offerMetaData?.cancellationPolicyInfo,
      filters,
      offer.property.timezone,
    )
  }, [offerMetaData?.cancellationPolicyInfo, filters, offer])
  const showModal = useContext(ModalContext)
  const openAllInclusionsModal = useCallback(() => {
    showModal(<Modal
      title={offer.property.name}
      primaryActionTo={getHotelOfferUrl(offer.id, offer.type)}
      primaryActionText="View offer"
    >
      <OfferInclusionsList inclusions={offer.inclusions!} />
    </Modal>)
  }, [showModal, offer])

  if (!offer.inclusions?.length) return null

  return <ExperimentalSearchTileFeaturesList
    features={offer.inclusions}
    featuresType="inclusions"
    cancellationPolicy={(offer.productType === 'limited_time_special' && (shownRate || cancellationPolicy)) && <BedbankCancellationPolicy
      icon={<LineCalendarIcon />}
      rate={shownRate ?? cancellationPolicy}
      showNonCancellation
    />}
    onMoreClick={openAllInclusionsModal}
  />
}

export default ExperimentalBedbankLTSSearchTileFeatures
